/* Candy4U MERCH COLLECTION PAGE (id: mrc8v), 2026-09-17.
   sections/candy-merch.liquid, snippets/candy-merch-card.liquid, assets/candy-merch.css.
   Four jobs:
     1. the size and colour chips pick one per card, so a size is chosen before anyone clicks in;
     2. the device filter shows only the cases for the phone that was picked;
     3. the size guide opens a small sheet;
     4. the video slot. A card shot with data-video="<url.mp4>" plays that clip in place of the photograph,
        on hover on desktop and when it comes into view on the phone, and falls back to the photograph
        everywhere else. No clips are in yet, so nothing plays and the badge marks the slot. */
(function () {
  var root = document.querySelector('[data-merch]');
  if (!root) return;

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. chips ---- */
  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-merch-chip]');
    if (!chip) return;
    var box = chip.parentNode;
    var on = chip.classList.contains('is-on');
    Array.prototype.forEach.call(box.querySelectorAll('[data-merch-chip]'), function (c) {
      c.classList.remove('is-on');
      c.setAttribute('aria-pressed', 'false');
    });
    if (!on) {
      chip.classList.add('is-on');
      chip.setAttribute('aria-pressed', 'true');
    }
  });

  /* ---- 2. device filter ---- */
  var cases = root.querySelector('[data-merch-cases]');
  if (cases) {
    var empty = cases.querySelector('[data-merch-empty]');
    cases.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-merch-device]');
      if (!btn) return;
      var want = btn.getAttribute('data-merch-device');
      Array.prototype.forEach.call(cases.querySelectorAll('[data-merch-device]'), function (b) {
        b.classList.toggle('is-on', b === btn);
      });
      var shown = 0;
      Array.prototype.forEach.call(cases.querySelectorAll('.custom-mrc8v__card'), function (card) {
        var list = (card.getAttribute('data-devices') || '').split(',');
        var ok = want === 'all' || list.indexOf(want) > -1;
        card.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    });
  }

  /* ---- 3. size guide ---- */
  var sheet = document.querySelector('[data-merch-sheet]');
  if (sheet) {
    root.addEventListener('click', function (e) {
      if (!e.target.closest('[data-merch-guide]')) return;
      sheet.hidden = false;
      var x = sheet.querySelector('[data-merch-sheet-close]');
      if (x) x.focus();
    });
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-merch-sheet-close]')) sheet.hidden = true;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) sheet.hidden = true;
    });
  }

  /* ---- 3b. the circle rail: scrolls smoothly and marks where you are ----
     The circles are the collection rail's, so the one for the section on screen carries the same lit
     ring the current collection does. */
  var jump = root.querySelector('.custom-mrc8v__rail');
  if (jump) {
    var links = Array.prototype.slice.call(jump.querySelectorAll('[data-merch-jump]'));

    /* Match the actual animated header edge, rather than its final visible/hidden state.
       The flow marker uses the same threshold as sticky positioning, so the solid background
       is present on the first pinned frame. All measured lengths are written as vw. */
    var mark = document.createElement('span');
    mark.setAttribute('aria-hidden', 'true');
    mark.setAttribute('data-merch-rail-marker', '');
    mark.style.cssText = 'display:block;height:var(--c4u-design-unit);margin:0;padding:0';
    jump.parentNode.insertBefore(mark, jump);
    var menu = document.querySelector('[data-mm]');
    var header = menu ? menu.closest('.shopify-section') : null;
    var railFrame = 0, followUntil = 0;
    function measuredValue(name, value, width) {
      var text = (value / width * 100).toFixed(6) + 'vw';
      if (root.style.getPropertyValue(name) !== text) root.style.setProperty(name, text);
    }
    function syncRail(now) {
      railFrame = 0;
      var width = window.innerWidth || document.documentElement.clientWidth;
      var visible = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var styles = getComputedStyle(jump);
      var gap = parseFloat(styles.getPropertyValue('--mrc-rail-gap')) * width / 100 || 0;
      var flow = mark.getBoundingClientRect().bottom + (parseFloat(styles.marginTop) || 0);
      var railHeight = jump.getBoundingClientRect().height;
      measuredValue('--mrc-header-visible', visible, width);
      measuredValue('--mrc-rail-height', railHeight, width);
      jump.classList.toggle('is-stuck', flow <= visible + gap + 1);
      if (now < followUntil) railFrame = requestAnimationFrame(syncRail);
    }
    function queueRail() { if (!railFrame) railFrame = requestAnimationFrame(syncRail); }
    function followHeader() { followUntil = performance.now() + 650; queueRail(); }
    window.addEventListener('scroll', queueRail, { passive: true });
    window.addEventListener('resize', followHeader, { passive: true });
    window.addEventListener('load', queueRail);
    window.addEventListener('pageshow', followHeader);
    if (header) {
      header.addEventListener('transitionrun', function (event) { if (event.target === header && event.propertyName === 'transform') followHeader(); });
      header.addEventListener('transitionend', function (event) { if (event.target === header && event.propertyName === 'transform') queueRail(); });
      header.addEventListener('transitioncancel', function (event) { if (event.target === header && event.propertyName === 'transform') followHeader(); });
      if ('MutationObserver' in window) {
        new MutationObserver(followHeader).observe(header, { attributes: true, attributeFilter: ['class'] });
        new MutationObserver(followHeader).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      }
    }
    if ('ResizeObserver' in window) {
      var railSize = new ResizeObserver(queueRail);
      railSize.observe(jump);railSize.observe(root);if (header) railSize.observe(header);
    }
    syncRail(performance.now());

    if ('IntersectionObserver' in window) {

      /* which section is on screen, so its circle lights up */
      var secs = links.map(function (a) { return document.querySelector(a.getAttribute('href')); });
      var seen = new IntersectionObserver(function (rows) {
        rows.forEach(function (row) {
          if (!row.isIntersecting) return;
          var i = secs.indexOf(row.target);
          if (i < 0) return;
          links.forEach(function (a, n) { a.classList.toggle('is-on', n === i); });
        });
      }, { rootMargin: '-25% 0px -60% 0px', threshold: 0 });
      secs.forEach(function (s) { if (s) seen.observe(s); });
    }

    jump.addEventListener('click', function (e) {
      var a = e.target.closest('[data-merch-jump]');
      if (!a) return;
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      links.forEach(function (x) { x.classList.toggle('is-on', x === a); });
      target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
    });
  }

  /* ---- 4. video slot ---- */
  function movie(shot) {
    var src = shot.getAttribute('data-video');
    if (!src) return null;
    var v = shot.querySelector('.custom-mrc8v__movie');
    if (v) return v;
    v = document.createElement('video');
    v.className = 'custom-mrc8v__movie';
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.preload = 'none';
    v.setAttribute('aria-hidden', 'true');
    v.src = src;
    shot.appendChild(v);
    return v;
  }
  function play(shot) {
    var v = movie(shot);
    if (!v) return;
    var go = v.play();
    if (go && go.catch) go.catch(function () {});
    shot.classList.add('is-playing');
  }
  function stop(shot) {
    var v = shot.querySelector('.custom-mrc8v__movie');
    if (!v) return;
    v.pause();
    shot.classList.remove('is-playing');
  }

  var shots = root.querySelectorAll('[data-video]');
  if (shots.length && !still) {
    if (fine) {
      Array.prototype.forEach.call(shots, function (shot) {
        var card = shot.closest('.custom-mrc8v__card') || shot;
        card.addEventListener('mouseenter', function () { play(shot); });
        card.addEventListener('mouseleave', function () { stop(shot); });
      });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (rows) {
        rows.forEach(function (row) {
          if (row.isIntersecting) play(row.target); else stop(row.target);
        });
      }, { threshold: 0.6 });
      Array.prototype.forEach.call(shots, function (shot) { io.observe(shot); });
    }
  }
})();
